import React, { lazy, Suspense } from 'react';
import { useNativeBookerStr } from './hooks/useNativeBookerStr';

const loadModule = () => import('@duda-co/booking/runtime');

export const NativeBooker = lazy(() =>
    loadModule().then((module) => ({ default: module.Booker }))
);

const NativeProvider = lazy(() =>
    loadModule().then((module) => ({ default: module.Provider }))
);

interface ProviderProps {
    clientId: string;
    apiUrl: string;
    language: string;
}

export function LazyNativeBookerWrapper({
    children,
    clientId,
    apiUrl,
    language,
}: {
    children: React.ReactNode;
} & ProviderProps) {
    const str = useNativeBookerStr();

    return (
        <Suspense>
            <NativeProvider
                clientId={clientId}
                options={{ apiUrl }}
                locale={language}
                str={str}
            >
                {children}
            </NativeProvider>
        </Suspense>
    );
}
